import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createStore, applyMiddleware, compose } from 'redux';

import rootReducer from './reducers/index';
import thunk from "redux-thunk";

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth', 'user', 'locale'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

let composeValue = compose(applyMiddleware(thunk));
if(process.env.REACT_APP_DEBUG === "true"){
    composeValue = compose(applyMiddleware(thunk), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
} else {
    composeValue = compose(applyMiddleware(thunk))
}

export const store = createStore(persistedReducer, composeValue)

export const persistor =  persistStore(store)
